import { Box, Grid, Stack } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ManagementUpdateHeader from "../../ManagementsUpdate/ManagementsUpdateHeader/ManagementsUpdateHeader";
import ManagementsCancelProcess from "../../Managements/ManagementsCancelProcess/ManagementsCancelProcess";
import ButtonElement from "../../UI/ButtonElement/ButtonElement";

interface ManagementAgentWrapperProps {
  children: React.ReactNode;
  step: number;
  title: string;
  submitButtonTitle: string;
  onSubmit: () => void;
  isButtonDisabled?: boolean;
}

export default function ManagementsAgentWrapper({
  children,
  step,
  title,
  onSubmit,
  submitButtonTitle,
  isButtonDisabled,
}: ManagementAgentWrapperProps) {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Box component="section" paddingBottom={{ md: "5rem" }}>
      <ManagementUpdateHeader title={title} step={step} />
      {step === 0 && (
        <Grid container justifyContent="center">
          <Grid item md={8} lg={7} flex={1}>
            <Stack
              bgcolor={{ md: "#fff" }}
              borderRadius="12px"
              boxShadow={{ md: "0px 3px 5px 0px rgba(55, 70, 73, 0.20)" }}
              padding="3rem"
              marginY="2.5rem"
              gap="2rem"
            >
              {children}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: "space-between",
                  gap: "1rem",
                  marginY: "1.5rem",
                }}
              >
                <ButtonElement onClick={onSubmit} disabled={isButtonDisabled}>
                  {submitButtonTitle}
                </ButtonElement>
                <ButtonElement
                  type="button"
                  secondary
                  onClick={() => setIsModalOpen(true)}
                >
                  {t("Cancelar")}
                </ButtonElement>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      )}

      {step > 0 && children}

      <ManagementsCancelProcess
        open={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
      />
    </Box>
  );
}
